<template>
  <v-navigation-drawer
    :value="isWhatsappConfigOpen"
    @input="inputWhatsappConfig"
    width="600px"
    right
    fixed
    temporary
    style="z-index: 200; transition: 0.5s cubic-bezier(0.4, 0, 0.2, 1)"
  >
    <v-card min-height="100vh" color="grey lighten-3">
      <BaseToolbar
        :button-save="true"
        :loader-save="saveLoading"
        :button-save-disabled="isSaveDisabled"
        @close="close"
        @save="save"
        :title="$t('organization.details.tabs.integrations.whatsapp.title')"
        type-title="icon"
        icon="edit"
      />
      <v-progress-linear v-if="loading" indeterminate height="5" class="my-0" />
      <div v-else class="pa-4">
        <v-card class="pa-2 custom_card" flat>
          <v-card-title>
            <v-icon>call</v-icon>
            <span class="title text_color ml-2">
              {{ $t('organization.details.tabs.integrations.whatsapp.title') }}
            </span>
          </v-card-title>
          <v-card-text>
            <v-row no-gutters>
              <v-col cols="12">
                <label for="whatsapp-sid" class="body-2 text_color">
                  SID
                </label>
                <v-text-field
                  id="whatsapp-sid"
                  v-model="localWhatsappConfiguration.sid"
                  :placeholder="
                    $t('organization.details.tabs.integrations.whatsapp.sid')
                  "
                  :rules="[
                    rules.required(localWhatsappConfiguration.sid, 'SID')
                  ]"
                  class="rounded-lg mt-1"
                  outlined
                  dense
                />
              </v-col>
              <v-col cols="12">
                <label for="whatsapp-token" class="body-2 text_color">
                  Token
                </label>
                <v-text-field
                  id="whatsapp-token"
                  v-model="localWhatsappConfiguration.token"
                  :placeholder="
                    $t('organization.details.tabs.integrations.whatsapp.token')
                  "
                  :rules="[
                    rules.required(localWhatsappConfiguration.token, 'Token')
                  ]"
                  class="rounded-lg mt-1"
                  outlined
                  dense
                />
              </v-col>
              <v-col cols="12">
                <label
                  for="whatsapp-messaging-service-id"
                  class="body-2 text_color"
                >
                  Messaging service ID
                </label>
                <v-text-field
                  id="whatsapp-messaging-service-id"
                  v-model="localWhatsappConfiguration.messagingServiceId"
                  :placeholder="
                    $t(
                      'organization.details.tabs.integrations.whatsapp.messaging_service_id'
                    )
                  "
                  class="rounded-lg mt-1"
                  outlined
                  dense
                />
              </v-col>
              <v-col cols="12">
                <label for="whatsapp-sub-account" class="body-2 text_color">
                  Sub-account
                </label>
                <v-switch
                  v-model="localWhatsappConfiguration.subAccount"
                  label="Sub-account"
                  color="#2661FF"
                  class="mt-2"
                />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </div>
    </v-card>
  </v-navigation-drawer>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import BaseToolbar from '@/components/BaseToolbar.vue'

export default {
  name: 'WhatsappConfig',
  components: { BaseToolbar },
  data() {
    return {
      loading: false,
      saveLoading: false,
      localWhatsappConfiguration: {
        sid: null,
        token: null,
        subAccount: false,
        messagingServiceId: null
      },
      rules: {
        required: (value, field) =>
          !!value ||
          this.$t('messages.validation_error.required', {
            field
          })
      }
    }
  },
  async created() {
    await this.fetchWhatsappKeys()
  },
  computed: {
    ...mapState({
      organization: ({ organization: { organization } }) => organization,
      integrations: ({ organization: { integrations } }) => integrations,
      orgIntegrations: ({ organization: { orgIntegrations } }) =>
        orgIntegrations,
      isWhatsappConfigOpen: ({ accounts: { isWhatsappConfigOpen } }) =>
        isWhatsappConfigOpen,
      whatsappConfiguration: ({ accounts: { whatsappConfiguration } }) =>
        whatsappConfiguration
    }),
    isSaveDisabled() {
      const { localWhatsappConfiguration, whatsappConfiguration } = this

      return (
        !localWhatsappConfiguration.sid ||
        !localWhatsappConfiguration.token ||
        (localWhatsappConfiguration.sid === whatsappConfiguration.sid &&
          localWhatsappConfiguration.token === whatsappConfiguration.token &&
          localWhatsappConfiguration.messagingServiceId ===
            whatsappConfiguration.messagingServiceId)
      )
    }
  },
  methods: {
    ...mapActions({
      fetchWhatsappKeysAction: 'accounts/fetchWhatsappKeys',
      saveWhatsappKeysAction: 'accounts/saveWhatsappKeys'
    }),
    ...mapMutations({
      toggleWhatsappConfig: 'accounts/toggleWhatsappConfig'
    }),
    async fetchWhatsappKeys() {
      const { id: organizationId } = this.organization

      this.loading = true
      await this.fetchWhatsappKeysAction({
        organizationId
      })

      const { whatsappConfiguration } = this

      this.localWhatsappConfiguration = {
        sid: whatsappConfiguration.sid,
        token: whatsappConfiguration.token,
        messagingServiceId: whatsappConfiguration.messagingServiceId,
        subAccount: whatsappConfiguration.subAccount
      }

      this.loading = false
    },
    inputWhatsappConfig(arg) {
      if (!arg) {
        this.toggleWhatsappConfig(false)
      }
    },
    close() {
      this.toggleWhatsappConfig(false)
    },
    async save() {
      const { localWhatsappConfiguration, organization } = this
      const { id: organizationId } = organization

      this.saveLoading = true
      const payload = {
        body: {
          ...localWhatsappConfiguration
        },
        organizationId
      }
      await this.saveWhatsappKeysAction(payload)
      this.saveLoading = false
    }
  }
}
</script>

<style lang="scss" scoped>
.text_color {
  color: #344054 !important;
}
</style>
